import { Fragment, useState } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { Modal, ModalBody, ModalFooter } from "reactstrap";

function ModalEditLinkCert({ onSubmit }) {
    const [data, setData] = useState("");
    const [isOpen, setIsOpen] = useState(false);
    const { t } = useTranslation();

    const handleChange = (e) => {
        setData(e.target.value);
    };

    const handleSubmit = () => {
        const urls = data
            ?.split(/\r?\n|,/)
            .map((url) => url.trim())
            .filter(Boolean)
            .slice(0, 4);
        if (urls?.length) onSubmit(urls);
        setIsOpen(false);
    };

    return (
        <Fragment>
            <button onClick={() => setIsOpen(true)} type="button" className="btn btn-primary ms-4">
                <i className="fa fa-cloud-upload mr-1"></i> {t("Import media from URL")}
            </button>
            <Modal
                centered={true}
                size="lg"
                toggle={() => {
                    setIsOpen(!isOpen);
                }}
                isOpen={isOpen}
            >
                <div className="modal-header">
                    <h1 className="mb-0 text-dark">{t("Import media from URL")}</h1>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal">
                        <i
                            className="ki-outline ki-cross fs-1"
                            onClick={() => {
                                setIsOpen(!isOpen);
                            }}
                        ></i>
                    </div>
                </div>
                <ModalBody>
                    <div className="form-group">
                        <label>URL</label>
                        <div>
                            <textarea
                                className="form-control"
                                name="list_image_url"
                                placeholder="https://image.com/1.png&#10;https://image.com/2.jpg&#10;https://file.com/certificate.pdf"
                                rows={5}
                                defaultValue={""}
                                onChange={handleChange}
                            ></textarea>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <button
                        type="reset"
                        id="kt_modal_users_search_reset"
                        data-bs-dismiss="modal"
                        className="btn btn-active-light me-3"
                        onClick={() => {
                            setIsOpen(!isOpen);
                        }}
                    >
                        {t("Cancel")}
                    </button>
                    <button
                        onClick={handleSubmit}
                        type="submit"
                        id="kt_modal_users_search_submit"
                        className="btn btn-primary"
                    >
                        {t("Save")}
                    </button>
                </ModalFooter>
            </Modal>
        </Fragment>
    );
}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ModalEditLinkCert);
